<div class="two-panel-layout">
  <div class="settings">

    <div class="master-card">
      <div class="master-row">
        <div>
          <h3 class="master-title">Enable Cruise Control</h3>
          <p class="setting-helper-text">Automatically create and manage offer sets. The settings below control how Cruise Control behaves when this feature is enabled.</p>
        </div>
        <div class="ad-types-header-input">
          @if (settings) {
            <p-toggleswitch [(ngModel)]="settings.enabled" (ngModelChange)="updateSettings()" />
          }
        </div>
      </div>
    </div>

    <div class="configuration-card">
      <span class="section-label">Configuration</span>

      <div class="status-grid">
        <div class="setting-content setting-content-column">
          <span class="setting-name">Default Offer Set Status</span>
          <span class="setting-helper-text">Choose the default status applied to newly created offer sets.</span>
          <div class="ad-types-header-input">
            @if (settings) {
              <p-selectButton
                [options]="generateAsOptions"
                [(ngModel)]="settings.generateAsPreview"
                (ngModelChange)="updateSettings()"
                [allowEmpty]="false"
                optionLabel="label"
                optionValue="value" />
            }
          </div>
        </div>

        @if (dealerAddOnOfferSetActiveEnabled && label === newLabel) {
          <div class="setting-content setting-content-column">
            <span class="setting-name">Dealer Add-on Offer Set Status</span>
            <span class="setting-helper-text">Determines whether Offer Sets with a Dealer Add-on are built as Active or Inactive via Cruise Control.</span>
            <div class="ad-types-header-input">
              @if (settings) {
                <p-selectButton
                  [options]="dealerAddOnOfferSetActiveOptions"
                  [(ngModel)]="settings.dealerAddOnOfferSetActive"
                  (ngModelChange)="updateSettings()"
                  [allowEmpty]="false"
                  optionLabel="label"
                  optionValue="value" />
              }
            </div>
          </div>
        }
      </div>

      <p-divider />

      <div class="setting-content setting-content-column">
        <span class="setting-name">
          Full Visibility Offer Set Settings
          <i class="pi pi-question-circle"
             pTooltip="Additional inventory-only offer sets may still be created for specific vehicles. When Inventory Only is disabled, this setting also determines how many offer sets are created."
             tooltipPosition="top"></i>
        </span>
        <span class="setting-helper-text">Controls the creation of offer sets that are available for use anywhere in the system (Landing Pages, Ad Platforms, Creative Advertising, etc. as well as VDPs and Leaderboards)</span>

      </div>

      <div class="full-visibility-group">
        <div class="full-visibility-group-row">
          <div>
            <span class="setting-name">Scope</span>
            <span class="setting-helper-text">Defines if offer sets are created for all vehicles or only for specific vehicles.</span>
          </div>
          <div class="ad-types-header-input compact-dropdown">
            @if (settings) {
              <p-selectButton
                [options]="buildByOptions"
                [(ngModel)]="settings.cruiseControlCreateLevelId"
                (ngModelChange)="updateSettings()"
                [allowEmpty]="false"
                optionLabel="label"
                optionValue="value" />
            }
          </div>
        </div>

        <div class="full-visibility-group-row">
          <div>
            <span class="setting-name">Vehicle Selection Criteria</span>
            <span class="setting-helper-text">Defines which vehicle is chosen when multiple vehicles qualify for Full Visibility.</span>
          </div>
          <div class="ad-types-header-input compact-dropdown">
            @if (settings && selectionCriteria.length > 0) {
              <p-select
                [options]="selectionCriteria"
                [(ngModel)]="settings.vehicleSelection"
                [disabled]="settings.cruiseControlCreateLevelId === 3"
                [appendTo]="'body'"
                (ngModelChange)="updateSettings()"
                optionLabel="criteria"
                optionValue="id">
              </p-select>
            }
          </div>
        </div>

        <div class="full-visibility-group-row">
          <div>
            <span class="setting-name">Minimum Image Requirement</span>
            <span class="setting-helper-text">Sets the minimum image count required before a vehicle can be used in a Full Visibility Offer Set.</span>
          </div>
          <div class="ad-types-header-input compact-dropdown small">
            @if (settings) {
              <p-select
                [options]="minimumImageOptions"
                [(ngModel)]="settings.minimumImageRequirement"
                [appendTo]="'body'"
                (ngModelChange)="updateSettings()"
                optionLabel="label"
                optionValue="value">
              </p-select>
            }
          </div>
        </div>
      </div>

      @if (offerSetVisibilityScopeEnabled) {
        <p-divider />

        <div class="setting-content setting-content-column">
          <span class="setting-name">
            Create Inventory Only Offer Sets for Remaining Inventory
            <i class="pi pi-question-circle"
               pTooltip="When enabled, an Inventory Only offer set is created for every vehicle not included in full visibility. When disabled, offer sets are created based on the Full Visibility scope above."
               tooltipPosition="top"></i>
          </span>
          <span class="setting-helper-text">Create offer sets for all remaining inventory. These offer sets will only be visible when viewing inventory (VDPs, Leaderboards, Feed-Based Advertising, etc.)</span>
          <div class="ad-types-header-input">
            @if (settings) {
              <p-selectButton
                [options]="generateAllInventoryOptions"
                [(ngModel)]="settings.generateAllInventory"
                (ngModelChange)="updateSettings()"
                [allowEmpty]="false"
                optionLabel="label"
                optionValue="value" />
            }
          </div>
        </div>
      }

    </div>
  </div>

  <p-card class="controls">
    <span class="section-label">Run Summary</span>

    <div class="summary-row">
      <div>
        <div class="setting-name">Run Cruise Control</div>
        <div class="setting-helper-text">Manually trigger offer set generation using the current configuration.</div>
      </div>
      <p-button
        [disabled]="viewState.runButtonDisabled"
        [label]="viewState.runButtonLabel"
        [icon]="viewState.runButtonIcon"
        styleClass="run-cruise-control-button"
        (click)="startCruiseControl()" />
    </div>

    <div class="summary-row">
      <div>
        <div class="setting-name">Current Status</div>
        <div class="setting-helper-text">Shows the latest execution state.</div>
      </div>
      @if (viewState.isStatusPillVisible) {
        <div class="status-pill" [ngClass]="viewState.statusClass">
          <span class="status-dot"></span>
          <span>{{viewState.statusLabel}}</span>
        </div>
      } @else {
        <div class="summary-value result-placeholder">{{viewState.statusLabel}}</div>
      }
    </div>

    <div class="summary-row">
      <div>
        <div class="setting-name">Latest Result</div>
        <div class="setting-helper-text">Outcome of the most recent completed run.</div>
      </div>
      <div class="summary-value" [ngClass]="viewState.latestResultClass">{{viewState.latestResultText}}</div>
    </div>

    <div class="summary-row">
      <div>
        <div class="setting-name">Latest Run</div>
        <div class="setting-helper-text">Timestamp of the most recent run attempt.</div>
      </div>
      @if (viewState.latestRunDate !== placeholderValue) {
        <div class="summary-value">{{viewState.latestRunDate | date: 'short'}}</div>
      } @else {
        <div class="summary-value result-placeholder">{{placeholderValue}}</div>
      }
    </div>
  </p-card>
</div>
